import React, { useEffect, useState } from "react";
import {
  Elements,
  useStripe,
  useElements,
  IbanElement
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_test_51QqrbNASUaI5R93fRyM6QdPOcrvg2ItvNZEetmRmJVwA0wi3cHIJfQ7ggSesGzlziPqjIkWacwehVCZkYqcgcFlD00TJ9K7WtR");

const IBANForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [clientSecret, setClientSecret] = useState("");
  const [formData, setFormData] = useState({ name: "", email: "" });

  useEffect(() => {
    // Create SetupIntent on mount
    fetch("http://localhost:5000/api/payment/create-sepa-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: formData.name || "Test User", email: formData.email || "test@example.com" })
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    const ibanElement = elements.getElement(IbanElement);
    const result = await stripe.confirmSepaDebitSetup(clientSecret, {
      payment_method: {
        sepa_debit: ibanElement,
        billing_details: {
          name: formData.name,
          email: formData.email,
        },
      },
    });

    if (result.error) {
      alert(`Error: ${result.error.message}`);
    } else {
      alert("IBAN Payment Method Setup Successful!");
      // redirect or save the result.setupIntent.payment_method if needed
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-xl mx-auto mt-20 p-6 bg-white shadow rounded space-y-6">
      <h2 className="text-2xl font-bold mb-4 text-center text-pink-600">SEPA IBAN Payment</h2>

      <input
        type="text"
        placeholder="Full Name"
        required
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        className="w-full p-3 border border-gray-300 rounded"
      />
      <input
        type="email"
        placeholder="Email"
        required
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        className="w-full p-3 border border-gray-300 rounded"
      />

      <label className="block text-gray-700 font-semibold">IBAN</label>
      <div className="p-3 border border-gray-300 rounded">
        <IbanElement
          options={{
            supportedCountries: ["SEPA"],
            placeholderCountry: "DE",
            style: {
              base: {
                fontSize: "16px",
                color: "#32325d",
              },
            },
          }}
        />
      </div>

      <button
        type="submit"
        disabled={!stripe}
        className="w-full bg-pink-600 text-white py-3 rounded hover:bg-pink-700"
      >
        Submit IBAN Payment
      </button>
    </form>
  );
};

const PaymentForm = () => (
  <Elements stripe={stripePromise}>
    <IBANForm />
  </Elements>
);

export default PaymentForm;
